// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Floating Chart Control Bar — auto-hide only (position/visuals live in
 * floating-chart-bar.module.css). Loaded via widget.css @import.
 * Hide rule wrapped in @media (hover: hover): on touch the rule never
 * applies so the bar stays visible (specificity (0,3,0) would otherwise
 * beat any (0,2,0) override — media queries don't add specificity).
 */
.rsc-engine-surface .vnsc-floating-bar {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
@media (hover: hover) {
  .rsc-engine-surface:not(:hover) .vnsc-floating-bar {
    opacity: 0;
    pointer-events: none;
    transform: translateX(-50%) translateY(4px);
  }
}
.rsc-engine-surface:focus-within .vnsc-floating-bar {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/floating-chart-bar.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;EACE,kDAAkD;AACpD;AACA;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,2CAA2C;EAC7C;AACF;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,yCAAyC;AAC3C","sourcesContent":["/**\r\n * Floating Chart Control Bar — auto-hide only (position/visuals live in\r\n * floating-chart-bar.module.css). Loaded via widget.css @import.\r\n * Hide rule wrapped in @media (hover: hover): on touch the rule never\r\n * applies so the bar stays visible (specificity (0,3,0) would otherwise\r\n * beat any (0,2,0) override — media queries don't add specificity).\r\n */\r\n.rsc-engine-surface .vnsc-floating-bar {\r\n  transition: opacity 0.2s ease, transform 0.2s ease;\r\n}\r\n@media (hover: hover) {\r\n  .rsc-engine-surface:not(:hover) .vnsc-floating-bar {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    transform: translateX(-50%) translateY(4px);\r\n  }\r\n}\r\n.rsc-engine-surface:focus-within .vnsc-floating-bar {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n  transform: translateX(-50%) translateY(0);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
